module.exports = __webpack_public_path__ + "img/box-arrow-in-down-right.8065dca3.svg";